export default "/images/logo.png?53220d188be908eb5678ba048a38d9c9";